module.exports = __webpack_public_path__ + "static/media/twelveth_miller_house7.2b050a6c.jpg";